import { render, staticRenderFns } from "./insteadTbLogin.vue?vue&type=template&id=55306e64&scoped=true&"
import script from "./insteadTbLogin.vue?vue&type=script&lang=js&"
export * from "./insteadTbLogin.vue?vue&type=script&lang=js&"
import style0 from "./insteadTbLogin.vue?vue&type=style&index=0&id=55306e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55306e64",
  null
  
)

export default component.exports